(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .factory('dashboardHelper', dashboardHelper);

  dashboardHelper.$inject = [];

  function dashboardHelper() {

    var service = {
      getNextCModuleInCourse: getNextCModuleInCourse
    };

    return service;

    ///////////////

    function getNextCModuleInCourse(course) {
      if (_.isEmpty(course.cModules))
        return null;

      var nextCModule;

      if (course.status != 'completed') {
        nextCModule = _.find(course.cModules, function (cModule) {
          return cModule.status != 'completed';
        });
      }

      return nextCModule || course.cModules[0];
    }
  }

})();
